<div class="flex flex-wrap items-center gap-2">
  @if (userCountByAdminState[UserState.ENABLED] > 0) {
    <pxc-user-admin-state-badge [count]="userCountByAdminState[UserState.ENABLED]" [state]="UserState.ENABLED" />
  }
  @if (userCountByAdminState[UserState.DISABLED] > 0) {
    <pxc-user-admin-state-badge [count]="userCountByAdminState[UserState.DISABLED]" [state]="UserState.DISABLED" />
  }
  @if (userCountByAdminState[UserState.INVITED] > 0) {
    <pxc-user-admin-state-badge [count]="userCountByAdminState[UserState.INVITED]" [state]="UserState.INVITED" />
  }
</div>
